import { apiClient } from "@nabble/sdk";

export type DataRequestKind = "ACCESS" | "RECTIFICATION" | "DELETION" | "OPPOSITION" | "PORTABILITY" | "BLOCKING";
export type DataRequestStatus = "OPEN" | "IN_PROGRESS" | "DONE" | "REJECTED";

/** A request the person made about their personal data (Chile Law 21.719). */
export interface DataRequest {
  id: string;
  kind: DataRequestKind;
  details: string | null;
  status: DataRequestStatus;
  createdAt: string;
  /** 30 calendar days after it was sent; 30 more once extended. */
  dueAt: string;
  extended: boolean;
  extensionReason: string | null;
  resolution: string | null;
  resolvedAt: string | null;
}

export function accountDataDownloadUrl(): string {
  return "/api/account/data";
}

export function fetchDataRequests(): Promise<DataRequest[]> {
  return apiClient<DataRequest[]>("/api/account/data-requests");
}

export function createDataRequest(kind: DataRequestKind, details: string): Promise<{ id: string }> {
  return apiClient<{ id: string }>("/api/account/data-requests", { method: "POST", body: { kind, details } });
}
